var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldBroom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.54 2.781c-.48-.78-1.43-1.22-2.32-.96-1.34.4-1.86 1.91-1.19 3.02l1.32 2.17c.15.23.46.31.69.17l2.61-1.59c.24-.15.32-.46.17-.69l-1.28-2.12zM16.93 10.41c-.98-1.32-2.68-1.94-4.28-1.51 0-.01-.01-.01-.01-.02l-1.66-2.73c-.3-.47-.92-.62-1.39-.33L6.12 7.93c-.48.28-.63.91-.34 1.39l1.65 2.73c0 .007.004.01.01.01a4.046 4.046 0 0 0-.61 4.51l2.08 4.24c.64 1.31 2.15 1.81 3.43 1.15.1-.05.13-.17.07-.27l-1.56-2.58a.765.765 0 0 1 .25-1.05c.36-.21.82-.1 1.05.25l1.57 2.58c.06.09.18.12.27.07l.96-.58c.09-.06.12-.18.07-.27l-1.57-2.58c-.21-.36-.1-.82.25-1.05.37-.21.83-.1 1.05.25l1.57 2.58c.06.09.18.12.27.07l.96-.58c.09-.06.12-.18.07-.27l-1.57-2.58c-.21-.36-.1-.82.25-1.05.37-.21.83-.1 1.05.25l1.58 2.57c.06.09.18.12.27.06 1.16-.83 1.42-2.39.54-3.57l-2.81-3.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldBroom);
export default __webpack_public_path__ + "static/media/vuesax-bold-broom.2412dc7555b67c4ca378c902c3409557.svg";
export { ForwardRef as ReactComponent };